import { DisbursementFuelTaxRequestProductModel } from './disbursement-fuel-tax-request-product.model';
import { ValidationModel } from '../../../shared/models/validation-results/validation.model';
import { DisbursementFuelTaxRequestDenialReasonModel } from './disbursement-fuel-tax-request-denial-reason.model';

export class DisbursementFuelTaxRequestModel extends ValidationModel {

    // Gets or sets the id
    public id: number;

    // Gets or sets the finance disbursement request identifier.
    public financeDisbursementRequestId: number;

    // Gets or sets the starting fiscal year id of the refund period.
    public startFiscalYearId: Date;

    // Gets or sets the ending fiscal year id of the refund period.
    public endFiscalYearId: Date;

    // Gets or sets the received date.
    public receivedDate: Date;

    // Gets or sets the number of days open.
    public daysOpen: number;

    // Gets or sets the assigned to user id.
    public assignedToUserId: number;

    // Gets or sets the assigned date.
    public assignedDate: Date;

    // Gets or sets the created by name.
    public createdBy: string;

    // Gets or sets the created date.
    public createdDate: Date;

    // Gets or sets the disbursement fuel tax request products.
    public fuelTaxRequestProducts: DisbursementFuelTaxRequestProductModel[];

    // Gets or sets the denial reasons
    public fuelTaxRequestDenialReasons: DisbursementFuelTaxRequestDenialReasonModel[];

    constructor(json: any) {
        super(json);
        json = this.getBody();

        this.fuelTaxRequestProducts = new Array<DisbursementFuelTaxRequestProductModel>();
        this.fuelTaxRequestDenialReasons = new Array<DisbursementFuelTaxRequestDenialReasonModel>();


        if (json) {
            this.id = json.id;
            this.financeDisbursementRequestId = json.financeDisbursementRequestId;
            this.startFiscalYearId = json.startFiscalYearId;
            this.endFiscalYearId = json.endFiscalYearId;
            this.receivedDate = new Date(json.receivedDate);
            this.daysOpen = json.daysOpen;
            this.assignedToUserId = json.assignedToUserId;
            this.assignedDate = json.assignedDate ? new Date(json.assignedDate) : null;
            this.createdBy = json.createdBy;
            this.createdDate = new Date(json.createdDate);

            json.fuelTaxRequestProducts.forEach(item => {
                var fuelTaxRequestProduct: DisbursementFuelTaxRequestProductModel = new DisbursementFuelTaxRequestProductModel(item);
                this.fuelTaxRequestProducts.push(fuelTaxRequestProduct);
            });

            json.fuelTaxRequestDenialReasons.forEach(item => {
                var fuelTaxRequestDenialReason: DisbursementFuelTaxRequestDenialReasonModel = new DisbursementFuelTaxRequestDenialReasonModel(item);
                this.fuelTaxRequestDenialReasons.push(fuelTaxRequestDenialReason);
            });
        } else {
            this.receivedDate = new Date(new Date().setHours(0, 0, 0, 0));
            this.daysOpen = 0;
        }
    }
}
